export enum BookingStep {
    FROM_TO = "fromTo",
    RESERVATION = "reservation",
    PASSENGERS = "passengers",
    SUMMARY = "summary",
}
